/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Paste_From_ClipboardInputs */

const en_dialog_text_to_audio_paste_from_clipboard = /** @type {(inputs: Dialog_Text_To_Audio_Paste_From_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste from clipboard`)
};

const es_dialog_text_to_audio_paste_from_clipboard = /** @type {(inputs: Dialog_Text_To_Audio_Paste_From_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar desde el portapapeles`)
};

/**
* | output |
* | --- |
* | "Paste from clipboard" |
*
* @param {Dialog_Text_To_Audio_Paste_From_ClipboardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_paste_from_clipboard = /** @type {((inputs?: Dialog_Text_To_Audio_Paste_From_ClipboardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Paste_From_ClipboardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_paste_from_clipboard(inputs)
	return en_dialog_text_to_audio_paste_from_clipboard(inputs)
});